/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StatisticCenter = {
    properties: {
        team: {
            type: 'array',
            contains: {
                type: 'StatisticV2',
            },
            isRequired: true,
        },
        player: {
            type: 'array',
            contains: {
                type: 'StatisticV2',
            },
            isRequired: true,
        },
    },
} as const;
